export const HOSPITAL_HEALTH_INFO_PAGE_SIZE = 3

export const HEALTH_INFO_URL = {
  LIST: (page = 1, size = 1000) => `/hospital/apis/health-info/unrestricted/list?page=${page}&size=${size}&sortCondition=CREATED_AT_DESC`,
  DETAIL: (id: number) => `/hospital/apis/health-info/unrestricted/detail/${id}`,
  HOSPITAL_LIST: (hospitalOriginId: number, page = 1, size = HOSPITAL_HEALTH_INFO_PAGE_SIZE) =>
    `/hospital/apis/health-info/unrestricted/hospitals/${hospitalOriginId}/list?page=${page}&size=${size}&sortCondition=CREATED_AT_DESC`,
}
